<template>
  <div class="container-fluid">
    <company-object-sidebar
      object-type="Dimension Group"
      :company-objects="dimensionGroups"
      :value="selectedDimensionGroup?.key"
      @input="selectDimensionGroup" />
    <div class="mr-6">
      <h2 class="mb-3">
        Dimension Groups
      </h2>
      <div class="editor">
        <div class="actions">
          <button
            :disabled="!dirty"
            @click="reset">
            Reset
          </button>
          <button
            :disabled="!dirty"
            @click="save">
            Save
          </button>
          <select
            v-model="selectedVersion"
            :disabled="!selectedGroupVersions">
            <option
              value=""
              disabled>
              History
            </option>
            <option
              v-for="version in selectedGroupVersions"
              :key="version.id"
              :value="version">
              {{ version.label }}
            </option>
          </select>
        </div>
        <schema-form
          v-if="selectedDimensionGroup"
          v-model="selectedDimensionGroupModel"
          :schema="schemas[testType]"
          :errors="errors"
          :all-schemas="schemas" />
      </div>
    </div>
  </div>
</template>

<script>
  import SchemaForm from '@/views/internal/schema_form/SchemaForm.vue'
  import CompanyObjectSidebar from '@/components/reports/config/common/CompanyObjectSidebar.vue'

  export default {
    name: 'DimensionGroups',
    components: {
      SchemaForm,
      CompanyObjectSidebar,
    },
    provide () {
      return {
        allSchemas: this.schemas,
      }
    },
    data () {
      return {
        schemas: null,
        dirty: false,
        testType: 'DimensionGroup',
        dimensionGroups: [],
        errors: [],
        selectedDimensionGroup: null,
        selectedGroupVersions: null,
      }
    },
    computed: {
      selectedVersion: {
        get () {
          return ''
        },
        set (version) {
          this.selectedDimensionGroup = structuredClone(version.config)
          this.dirty = true
        },
      },
      selectedDimensionGroupModel: {
        get () {
          return this.selectedDimensionGroup
        },
        set (value) {
          this.dirty = true
          this.selectedDimensionGroup = value
        },
      },
    },
    mounted () {
      this.loadApiSchemas()
      this.loadDimensionGroups()
    },
    methods: {
      reset () {
        this.errors = []
        this.selectDimensionGroup(this.selectedDimensionGroup.key)
      },
      async save () {
        let saveAttempt = await this.$apis.companyConfigs.content.dimensionGroups.set(this.selectedDimensionGroup)
        if (!saveAttempt.success) {
          this.errors = saveAttempt.errors.errors
        } else {
          await this.loadDimensionGroups()
          this.reset()
        }
      },
      async selectDimensionGroup (dimensionGroup) {
        this.selectedDimensionGroup = structuredClone(this.dimensionGroups.find(group => group.key == dimensionGroup))
        this.loadVersions()
        this.dirty = false
      },
      async loadApiSchemas () {
        this.schemas = (await this.$apis.app.getExporterApiSpec()).components.schemas
      },
      async loadVersions () {
        let key = this.selectedDimensionGroup.key
        this.selectedGroupVersions = []
        let response = await this.$apis.companyConfigs.content.dimensionGroups.versions(key)
        if (key == this.selectedDimensionGroup.key) {
          this.selectedGroupVersions = response
        }
      },
      async loadDimensionGroups () {
        this.dimensionGroups = await this.$apis.companyConfigs.content.dimensionGroups.list()
      },
    },
  }
</script>

<style lang="scss" scoped>
.container-fluid {
  background: #F5F5F5;
  width: 100%;
  min-height: 1000px;
  display: flex;
  flex-direction: row;

  h2 {
    font-size: 17px;
  }

}
</style>
